import { useEffect } from "react";
import { useLocation } from "wouter";

export function usePageTracking() {
  const [path] = useLocation();
  useEffect(() => {
    if (path.startsWith("/admin")) return;
    let sent = false;
    const send = () => {
      if (sent) return;
      if (window.location.pathname.startsWith("/admin")) return;
      sent = true;
      observer.disconnect();
      // Update the browser title before GTM can consume the page-view event.
      // Never reuse a previous route's title when this page has no heading.
      document.title = document.querySelector("h1")?.textContent?.trim()
        || "Michigan Trauma Coalition";
      const target = window as Window & { dataLayer?: Record<string, unknown>[] };
      (target.dataLayer ??= []).push({
        event: "page_view",
        page_path: window.location.pathname,
        page_title: document.title,
      });
    };
    const checkHeading = () => {
      if (document.querySelector("h1")?.textContent?.trim()) send();
    };
    const observer = new MutationObserver(checkHeading);
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
    const timer = window.setTimeout(checkHeading, 0);
    const fallback = window.setTimeout(send, 3000);
    return () => {
      observer.disconnect();
      window.clearTimeout(timer);
      window.clearTimeout(fallback);
    };
  }, [path]);
}
